import { useDashboardMutations } from "MyDashboards/api/useDashboards.hook";
import useDashboardStore from "MyDashboards/state/useDashboardStore";
import { Dashboard } from "MyDashboards/types/api";
import useCurrentUser from "qpr-base/context/UserContext";
import useLink from "qpr-base/hooks/useLink";
import React from "react";
import { useTranslation } from "react-i18next";
import { If } from "react-if";
import { ReactComponent as DashboardIcon } from "../../assets/my_dashboard_dashboard_icon.svg";
import { ReactComponent as SharedIcon } from "../../assets/mydashboard_shared_icon.svg";
import DeleteModal from "../DeleteModal";
import MoreBtn from "../MoreBtn";
import ShareModal from "../ShareModal/ShareModal";
import useDashboardStyles from "./theme";

const MyDashboard = (props: {
  dashboard: Dashboard;
  onDashboardUpdated: VoidFunction;
}) => {
  const classes = useDashboardStyles();
  const { t } = useTranslation();
  const activeUser = useCurrentUser();
  const { dashboard } = props;
  const isDashboardOwner =
    activeUser?.profile?.meaUserId === dashboard.creatorID;
  const showShareIcon =
    dashboard.usersSharedWith && dashboard.usersSharedWith.length > 0;
  const showContextMenu = isDashboardOwner;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const mutations = useDashboardMutations();
  const store = useDashboardStore();
  const link = useLink({ noPeriod: true });

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };
  const onDeleteDashboard = async () => {
    // logic to delete dashboard here
    // conditionaly close the modal
    closeDeleteModal();
    props.onDashboardUpdated();
    try {
      await mutations.remove.mutate(dashboard._id);
      store.removeDashboard(dashboard._id);
    } catch (e) {
      console.error(e);
    }
  };

  const [isShareModalOpen, setIsShareModalOpen] = React.useState(false);
  const openShareModal = () => {
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const onShareDashboard = () => {
    // logic to Share dashboard here
    // conditionaly close the modal
    closeShareModal();
    props.onDashboardUpdated();
  };

  return (
    <div className={classes.card} key={dashboard._id}>
      <div
        className="wrapper"
        onKeyDown={() => {
          link({ page: "viewdashboard", meaId: dashboard._id, period: "" });
        }}
        onClick={() => {
          link({ page: "viewdashboard", meaId: dashboard._id, period: "" });
        }}
        tabIndex={0}
        role="button"
      >
        <If condition={showContextMenu}>
          <div className="actionIcon">
            <MoreBtn
              dashboard={dashboard}
              onDelete={openDeleteModal}
              onEdit={() => {}}
              onShare={openShareModal}
              id={dashboard._id}
            />
          </div>
        </If>
        <If condition={showShareIcon}>
          <SharedIcon className="sharedIcon" />
        </If>
        <DashboardIcon />
        <p>{dashboard.name}</p>
      </div>
      {isDeleteModalOpen ? (
        <DeleteModal
          name={dashboard.name}
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onAccept={onDeleteDashboard}
        />
      ) : null}
      {isShareModalOpen ? (
        <ShareModal
          open={isShareModalOpen}
          onClose={closeShareModal}
          dashboard={props.dashboard}
        />
      ) : null}
    </div>
  );
};

export default MyDashboard;
